export const isObject = (obj) => obj === Object(obj);

export const toObject = (value, term = "value") =>
  isObject(value) ? value : { [term]: JSON.stringify(value) };

export const flattenObject = (obj, prefix = "") =>
  isObject(obj)
    ? Object.keys(obj).reduce((acc, k) => {
        const pre = prefix.length ? prefix + "_" : "";
        if (isObject(obj[k]))
          Object.assign(acc, flattenObject(obj[k], pre + k));
        else acc[pre + k] = obj[k];
        return acc;
      }, {})
    : obj;

export const createCounter = (startAt = 0) =>
  (
    (i) => () =>
      i++
  )(startAt);

export const tryc = (toEval, fallback) => {
  try {
    return toEval();
  } catch {
    return fallback;
  }
};
